import { render, staticRenderFns } from "./listShippingCompany.vue?vue&type=template&id=7df8c118&"
import script from "./listShippingCompany.vue?vue&type=script&lang=js&"
export * from "./listShippingCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports